
export default {
	status: state => state.status,
	navigation: (state, getters, rootGetters) => {
		return state.navigation.filter(route => {
			if (route.meta.permissions) {
				const user = rootGetters['Auth'].user
				const permissionMethod = route.meta.permissionMethod || 'hasSomePermission'
				const matchMethod = route.meta.permissionMatch === 'some' ? 'some' : 'every'

				if (!user || typeof user[permissionMethod] !== 'function') {
					return false
				}

				return route.meta.permissions[matchMethod](permission => {
					return user[permissionMethod](permission)
				})
			}
			return true
		}).sort((a, b) => {
			if (a.meta.sort && b.meta.sort) {
				return a.meta.sort - b.meta.sort
			} else {
				return false
			}
		})
	}
}
